export default __webpack_public_path__ + "static/media/dashboard.5651e755.png";